import { useQuery } from '@tanstack/react-query'
import { getRebalanceView } from '@/lib/rebalanceApi'

export function useRebalanceView(cashInput?: number | null) {
  return useQuery({
    queryKey: ['rebalance', { cashInput: cashInput ?? null }],
    queryFn: () => getRebalanceView({ cashInput }),
    staleTime: 30_000,
  })
}
